import { Subscribe } from '@react-rxjs/core'
import React from 'react'

import { useLatestCartFooterHeight } from '../../lib/cart/footer'

export interface CartFooterSpacerProps {
  className?: string
  fallbackHeight: number
}

const Spacer: React.FC<CartFooterSpacerProps> = ({ className, fallbackHeight }) => {
  const footerHeight = useLatestCartFooterHeight()
  return (
    <div
      className={className}
      style={{ paddingTop: footerHeight || fallbackHeight, width: '100%' }}
    />
  )
}

export const CartFooterSpacer: React.FC<CartFooterSpacerProps> = (props) => (
  <Subscribe fallback={<React.Fragment />}>
    <Spacer {...props} />
  </Subscribe>
)
